import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '../../assets/images/svg/sq-arrow-left.svg';
import _imports_1 from '../../assets/images/svg/sq-arrow-right.svg';
const _hoisted_1 = {
    key: 0,
    class: "tw-pb-4 tw-space-y-6"
};
const _hoisted_2 = { class: "tw-space-y-3" };
const _hoisted_3 = {
    key: 0,
    class: "tw-w-full"
};
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "single-slide" };
const _hoisted_6 = { class: "box tw-mb-4" };
const _hoisted_7 = { class: "img-box" };
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
    key: 1,
    class: "tw-w-full tw-my-5"
};
const _hoisted_10 = { class: "row" };
const _hoisted_11 = { class: "single-slide" };
const _hoisted_12 = { class: "box tw-mb-4" };
const _hoisted_13 = { class: "img-box" };
const _hoisted_14 = ["src", "alt"];
const _hoisted_15 = {
    key: 1,
    class: "tw-text-center tw-text-sm tw-text-gray-500"
};
import { ref, onMounted, onUnmounted, watch } from "vue";
import { useRouter } from "vue-router";
import { useLogo } from "@/hooks/useLogo";
import { useSidebar } from "@/stores/sidebar";
import GamesByProviders from "./GamesByProviders.vue";
// Props
export default /*@__PURE__*/ _defineComponent({
    __name: 'CasinoComponentForAll',
    props: {
        games: {},
        casinoSideBarCategories: {},
        gameCategories: {},
        selectedCategory: {},
        isLoading: { type: Boolean }
    },
    emits: ["viewGames"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const gameUrl = ref(null);
        const scrollContainer = ref(null);
        const router = useRouter();
        const logo = useLogo();
        const { handleCloseSidebar } = useSidebar();
        const activeAccordion = ref(null);
        // Search query ref
        const searchQuery = ref('');
        // Function to check if a category or game is selected
        const isSelected = (href) => router.currentRoute.value.path === href;
        const filteredGames = (gameCat) => {
            return props.games.filter((game) => game.gamebank === gameCat.gameType &&
                game.name.toLowerCase().includes(searchQuery.value.toLowerCase()));
        };
        const showProviders = ref(false);
        const toggleProviders = () => {
            showProviders.value = !showProviders.value;
        };
        const activeCategoryId = ref(null);
        const toggleView = (categoryId) => {
            emit('viewGames', { title: 'All', id: null });
            router.replace({ path: '/casino/all' });
            activeCategoryId.value = activeCategoryId.value === categoryId ? null : categoryId;
        };
        const config = ref({
            itemsToShow: 16,
            autoplay: 3000,
            infinite: true,
            gap: 10,
        });
        const screenWidth = ref(window.innerWidth);
        watch(screenWidth, (newWidth) => {
            if (newWidth < 640) {
                config.value.itemsToShow = 3;
            }
            else {
                config.value.itemsToShow = 6;
            }
        });
        // Update screenWidth on window resize
        onMounted(() => {
            const handleResize = () => {
                screenWidth.value = window.innerWidth;
            };
            window.addEventListener("resize", handleResize);
            onUnmounted(() => {
                window.removeEventListener("resize", handleResize);
            });
        });
        return (_ctx, _cache) => {
            const _component_Card = _resolveComponent("Card");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _cache[3] || (_cache[3] = _createElementVNode("nav", { class: "tw-pb-4 tw-space-y-6" }, [
                    _createElementVNode("div", { class: "tw-space-y-3" })
                ], -1)),
                (_ctx.selectedCategory && _ctx.selectedCategory.title === 'All')
                    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.casinoSideBarCategories, (gameCat) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: gameCat.id,
                                        class: "tw-border-none tw-p-0"
                                    }, [
                                        (!activeCategoryId.value || activeCategoryId.value === gameCat.id)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "tw-w-full tw-p-0 tw-mb-0" }, [
                                                    _createElementVNode("div", { class: "tw-transition-all tw-duration-300 tw-ease-in-out tw-border-l-2 tw-cursor-pointer tw-text-[#738499] tw-group tw-border-l-transparent" })
                                                ], -1)),
                                                (activeCategoryId.value === gameCat.id)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                        _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"tw-w-full tw-my-2 tw-flex tw-justify-between\"><div class=\"tw-flex tw-gap-2\"><img src=\"" + _imports_0 + "\" alt=\"Previous\" class=\"tw-w-[44px] tw-h-[45px]\"></div><div class=\"tw-flex tw-gap-2\"><img src=\"" + _imports_1 + "\" alt=\"Next\" class=\"tw-w-[44px] tw-h-[45px]\"></div></div>", 1)),
                                                        _createVNode(_component_Card, { class: "tw-border-none tw-pb-6 tw-w-full tw-bg-transparent" }, {
                                                            default: _withCtx(() => [
                                                                (filteredGames(gameCat).length)
                                                                    ? (_openBlock(), _createElementBlock("div", {
                                                                        key: 0,
                                                                        ref_for: true,
                                                                        ref_key: "scrollContainer",
                                                                        ref: scrollContainer
                                                                    }, [
                                                                        _createElementVNode("div", _hoisted_4, [
                                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGames(gameCat).slice(0, 20), (game) => {
                                                                                return (_openBlock(), _createElementBlock("div", {
                                                                                    key: game.id,
                                                                                    class: "col-25"
                                                                                }, [
                                                                                    _createElementVNode("div", _hoisted_5, [
                                                                                        _createElementVNode("div", _hoisted_6, [
                                                                                            _createElementVNode("div", _hoisted_7, [
                                                                                                _createElementVNode("img", {
                                                                                                    src: `https://azurecoinz.com/frontend/Default/ico/${game.name}.jpg`,
                                                                                                    alt: game.name,
                                                                                                    class: "tw-object-cover tw-rounded tw-w-full tw-h-full"
                                                                                                }, null, 8, _hoisted_8)
                                                                                            ])
                                                                                        ])
                                                                                    ])
                                                                                ]));
                                                                            }), 128))
                                                                        ])
                                                                    ], 512))
                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            _: 2
                                                        }, 1024)
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                        _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"tw-w-full tw-my-2 tw-flex tw-justify-between\"><div class=\"tw-flex tw-gap-2\"><img src=\"" + _imports_0 + "\" alt=\"Previous\" class=\"tw-w-[44px] tw-h-[45px]\"></div><div class=\"tw-flex tw-gap-2\"><img src=\"" + _imports_1 + "\" alt=\"Next\" class=\"tw-w-[44px] tw-h-[45px]\"></div></div>", 1)),
                                                        _createVNode(_component_Card, { class: "tw-border-none tw-pb-6 tw-w-full tw-bg-transparent" }, {
                                                            default: _withCtx(() => [
                                                                (filteredGames(gameCat).length)
                                                                    ? (_openBlock(), _createElementBlock("div", {
                                                                        key: 0,
                                                                        ref_for: true,
                                                                        ref_key: "scrollContainer",
                                                                        ref: scrollContainer,
                                                                        class: ""
                                                                    }, [
                                                                        _createElementVNode("div", _hoisted_10, [
                                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGames(gameCat).slice(0, 20), (game) => {
                                                                                return (_openBlock(), _createElementBlock("div", {
                                                                                    key: game.id,
                                                                                    class: "col-25"
                                                                                }, [
                                                                                    _createElementVNode("div", _hoisted_11, [
                                                                                        _createElementVNode("div", _hoisted_12, [
                                                                                            _createElementVNode("div", _hoisted_13, [
                                                                                                _createElementVNode("img", {
                                                                                                    src: `https://azurecoinz.com/frontend/Default/ico/${game.name}.jpg`,
                                                                                                    alt: game.name,
                                                                                                    class: "tw-object-cover tw-rounded tw-w-full tw-h-full"
                                                                                                }, null, 8, _hoisted_14)
                                                                                            ])
                                                                                        ])
                                                                                    ])
                                                                                ]));
                                                                            }), 128))
                                                                        ])
                                                                    ], 512))
                                                                    : (_openBlock(), _createElementBlock("p", _hoisted_15, " No games available "))
                                                            ]),
                                                            _: 2
                                                        }, 1024)
                                                    ]))
                                            ], 64))
                                            : _createCommentVNode("", true)
                                    ]));
                                }), 128))
                            ])
                        ])
                    ]))
                    : (_openBlock(), _createBlock(GamesByProviders, {
                        key: 1,
                        games: _ctx.games,
                        selectedCategory: _ctx.selectedCategory,
                        isLoading: _ctx.isLoading
                    }, null, 8, ["games", "selectedCategory", "isLoading"]))
            ], 64));
        };
    }
});
